import { Checkbox } from "@snapchat/snap-design-system";
import { css } from "@emotion/css";
import { type FC, useCallback } from "react";
import { ItemCard, ItemName } from "../../common/styles";
import { checkboxStyle } from "../../common/styles/Checkbox.styles";
import { type SourceModel } from "../models";

const sourceItemStyle = css`
    padding: 15px 10px;
`;

interface LensSourcesListItemProps {
    source: SourceModel;
    onClick: (source: SourceModel) => void;
    isSelected: boolean;
}

export const LensSourcesListItem: FC<LensSourcesListItemProps> = ({ onClick, isSelected, source }) => {
    const { name } = source;

    const handleClick = useCallback(() => {
        onClick(source);
    }, [source, onClick]);

    return (
        <ItemCard justifyContent="space-between" alignItems="center" onClick={handleClick}>
            <ItemName className={sourceItemStyle}>{name}</ItemName>
            <Checkbox value={isSelected} checkboxClassName={checkboxStyle} />
        </ItemCard>
    );
};
